import apiFetch from '../../apiFetch'

export default function (token) {
  return apiFetch({ endPoint: 'DossierHomologation/ClassificationList', method: 'GET', body: null, token: token })
}
